import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import DisplayName from '@99designs/react-components/components/DisplayName';
import Avatar from '@99designs/react-components/components/Avatar';
import FavoriteDesigner from 'apps/favorite-designer/FavoriteDesigner';
import connectToOnlineStatus from 'components/connectToOnlineStatus';

const ConnectedAvatar = connectToOnlineStatus(Avatar);

export default class DesignAttribution extends React.Component {
    avatar() {
        if (this.canViewOnlineStatus()) {
            return (
                <ConnectedAvatar
                    user={this.avatarUser()}
                    variations={['small']}
                    lastSeenTimesUrl={this.props.design.links.lastSeenTimesUrl}
                />
            );
        }
        return (
            <Avatar
                user={this.avatarUser()}
                variations={['small']}
            />
        );
    }

    canViewOnlineStatus() {
        return (!!this.props.activeUser.id
            && (this.props.activeUser.id !== this.props.design.creator.userId));
    }

    userSection() {
        return (
            <div className="user user--padded">
                <a className="user__avatar" href={this.props.design.creator.showUrl} >
                    {this.avatar()}
                </a>
                <span className="user__display-name">
                    <FormattedMessage
                        className="display-name"
                        id="designed_by_user"
                        values={{
                            user: (<DisplayName isLinked user={this.props.design.creator} />),
                        }}
                    />
                    {this.favoriteAbility()}
                </span>
            </div>
        );
    }

    favoriteAbility() {
        if (this.props.design.permission.canFavorite) {
            return (
                <span className="like-button like-button--offset-left">
                    <FavoriteDesigner
                        designer={this.props.design.creator}
                        xhrUrl={this.props.design.dataFavoriteDesignerUrl}
                    />
                </span>
            );
        }

        return null;
    }

    categoryInfo() {
        if (this.props.design.categoryEntryInfo) {
            return (
                <a href={this.props.design.links.contestUrl} className="link">
                    {this.props.design.categoryEntryInfo}
                </a>
            );
        }

        return null;
    }

    avatarUser() {
        return {
            avatarUrl: this.props.design.creator.avatarUrl,
            id: this.props.design.creator.userId,
        };
    }

    render() {
        return (
            <div className="sidebar-header__sub-heading">
                {this.userSection()}
                {this.categoryInfo()}
            </div>
        );
    }
}

DesignAttribution.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    activeUser: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/DesignAttribution.jsx